<span [ngSwitch]="id">
  <span class="badge bg-secondary" *ngSwitchCase="1">{{'unitValue.'+id | translate}}</span>
  <span class="badge bg-secondary" *ngSwitchCase="2">{{'unitValue.'+id | translate}}</span>
  <span class="badge bg-secondary" *ngSwitchCase="3">{{'unitValue.'+id | translate}}</span>
  <span class="badge bg-secondary" *ngSwitchCase="5">{{'unitValue.'+id | translate}}</span>
  <span class="badge bg-secondary" *ngSwitchDefault> {{'unitValue.'+id | translate}}</span>
</span>
